import React, { useEffect, useRef, useState } from 'react'
import { Outlet } from 'react-router-dom'
import Footer from '../components/general/Footer'
import Navbar from '../components/general/Navbar'
import AnimatedCursor from 'react-animated-cursor'
import ContactForm from '../components/general/ContactForm'
import whatsapp from '../assets/general/social/Icon-whatsapp.svg'

import introVideo from '../assets/general/BludoorSplash.mp4'

import { useLocation } from 'react-router-dom';
import AOS from 'aos'

const Layout = () => {


  const location = useLocation();
  const [pathname, setPathname] = useState("/")

  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out', 
      once: true,
    });
  }, []);

  useEffect(() => {
    setPathname(location.pathname);
  }, [location]);

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[]) 


  const [isContact, setIsContact] = useState(false)

  
  const [videoPlay, setVideoPlay] = useState(true);

  const [isPlaying, setIsPlaying] = useState(true);

  const videoRef = useRef(null);

  useEffect(() => {
    const handleVideoEnd = () => setIsPlaying(false);
    videoRef.current.addEventListener('ended', handleVideoEnd);

    const timeoutId = setTimeout(() => setIsPlaying(false), 7000);

    return () => {
      videoRef.current.removeEventListener('ended', handleVideoEnd);
      clearTimeout(timeoutId);
      setVideoPlay(false);
    };
  }, [introVideo, 3000]);


    return (
        <div className='w-full h-fit font-mosk300' >

{isDesktop && <AnimatedCursor
  innerSize={8}
  outerSize={50}
  innerScale={1}
  outerScale={2.7}
  outerAlpha={0}
  outerStyle={{
    border: '2px solid #0095da'
  }}
  innerStyle={{
    backgroundColor: '#ff1f2b'
  }}
  className="hidden md:block"
/>}
    
    

        {isPlaying && ((pathname === "") || (pathname === "/")) && (
        <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        zIndex: '1000'
      }}
    >
    
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          preload="auto"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
          src={introVideo}
        />
      
    </div>

    )}

          
          <Navbar setVideoPlay={setVideoPlay} setIsContact={setIsContact} />

          <ContactForm isContact={isContact} setIsContact={setIsContact}  />

          <a href="https://wa.me/+919052224966" target='_blank'><img className='w-[50px] h-[50px] z-20 fixed bottom-4 right-4 drop-shadow-xl animate-upDown' src={whatsapp} alt="" /></a>
          
          <Outlet />

          <Footer />
        </div>
    )
}

export default Layout
